import { useEffect, useState } from "react";

import { ActiveBrandList } from "../../../../../redux/services/BrandService/brand.Services";
import { ActiveUnitList } from "../../../../../redux/services/UnitService/unit.Services";
import { ActiveCategoryList } from "../../../../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../../../../redux/services/subCategoriesService/subCategories.Services";
import { ActiveSizeList } from "../../../../../redux/services/UnitSize/unit-size.Services";
import { ActiveColorList } from "../../../../../redux/services/ColorServices/color.Services";
import { ActiveUserList } from "../../../../../redux/services/User Services/User.Services";

// import { getUserListByCategory } from "../../../../../redux/services/User Services/User.Services";
export default function useDropdownData() {
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [users, setUsers] = useState([]);
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [patterns, setPatterns] = useState([]);
    const [styles, setStyles] = useState([]);
    const [genders, setGenders] = useState([]);
    const [seasons, setSeasons] = useState([]);
    const [brands, setBrands] = useState([]);
    const [units, setUnits] = useState([]);
    useEffect(() => {
        loadData();
    }, []);

    async function loadData() {

        try {
            // const categoryRes = await ActiveCategoryList();
             const childRes = await ActiveCategoryList();
            const childData = childRes?.data || [];
            const catMap = new Map();
            const subCatMap = new Map();
            childData.forEach(item => {
                const subCat = item.sub_category_details;
                const cat = subCat?.category_details;
                if (cat && !catMap.has(cat.id)) {
                    catMap.set(cat.id, cat);
                }
                if (subCat && !subCatMap.has(subCat.id)) {
                    subCatMap.set(subCat.id, subCat);
                }
            });
                  setCategories(Array.from(catMap.values()));
            setSubCategories(Array.from(subCatMap.values())); 
            const brandRes = await ActiveBrandList();
            setBrands(brandRes?.data || []);
            const unitRes = await ActiveUnitList();
            setUnits(unitRes?.data || []);
            const userRes = await ActiveUserList();
            if (userRes?.success) {
                setUsers(userRes?.data || []);
            }
        } catch (error) {
            console.log(error);
        }
    }
    async function loadColors(payload) {
        try {
            const res = await ActiveColorList(payload);
            setColors(res.data || []);
        } catch (error) {

            console.log(error);

            setColors([]);
        }
    }
    async function loadSubCategory(categoryId) {
        try {
            const childRes = await ActiveCategoryList();
            const childData = childRes?.data || [];

            const filtered = [];
            const seen = new Set();

            childData.forEach(item => {
                const subCat = item.sub_category_details;
                if (subCat && String(subCat.category_id) === String(categoryId) && !seen.has(subCat.id)) {
                    seen.add(subCat.id);
                    filtered.push(subCat);
                }
            });

            setSubCategories(filtered);
        } catch (error) {
            console.log(error);
            setSubCategories([]);
        }
    }
    // async function getCategoryByUser(userId) {
    //     try {
    //         const res = await getUserListByCategory({
    //             user_id: userId,
    //         });
    //         return res;
    //     } catch (error) {
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async function loadColors(payload) {
    //     try {
    //         const payload={

    //         }
    //         const res = await getColorByCategory(payload);
    //         setColors(res.data || []);
    //     } catch (error) {
    //         console.log(error);
    //         setColors([]);
    //     }
    // }

    async function loadSizes(payload) {
        try {
            const res = await ActiveSizeList(payload);
            setSizes(res.data || []);
        } catch (error) {
            console.log(error);
            setSizes([]);
        }
    }

    async function loadDynamicDropdowns(payload) {

        await loadColors(payload);
        //  
        await loadSizes(payload);

    }

    return {
        users,
        categories,
        subCategories,
        brands,
        units,
        loadSubCategory,
        loadData,
        loadDynamicDropdowns,
        loadColors,
        loadSizes,
        materials,
        // getCategoryByUser,
        colors,
        patterns,
        sizes,
        styles,

        genders,

        seasons,

        loadSubCategory,

    };

}